import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import BranchInquiry from "../admin/inquiry/branchInquiry";
import StoreInquiry from "../admin/inquiry/storeInquiry";
import RiderInquiry from "../admin/inquiry/riderInquiry";
import OtherInquiry from "../admin/inquiry/otherInquiry";
export const DialogModal = ({ open, close, title, type, dataItem, refreshList }) => {


  return (
    <Dialog
      open={open}
      onClose={close}
      id="AdminDialog"
      PaperProps={{
        sx: {
          width: 'fit-content', // 너비를 내용에 맞게 설정
          maxWidth: 'none', // maxWidth 없애기
          // margin: '0 24px 20px 24px', // margin 설정
          overflowY: 'hidden', // overflow-y 제거
        },
      }}
    >
      <DialogTitle sx={{
        padding: '40px 40px 0 40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '24px',
        fontWeight: 'bold'
      }}>
        <span>{title}</span>
        <Button
          onClick={close}
        >
          <CloseIcon sx={{ color: 'black' }} />
        </Button>
      </DialogTitle>
      <DialogContent
        sx={{
          '@media (max-width: 840px)': {
            margin: '0',
          },
          margin: '0 20px 40px 24px',
          padding: '30px',
        }}
      >
        {dataItem.category === 0 && <BranchInquiry data={dataItem} refreshList={refreshList} />}
        {dataItem.category === 1 && <StoreInquiry data={dataItem} refreshList={refreshList} />}
        {dataItem.category === 2 && <RiderInquiry data={dataItem} refreshList={refreshList} />}
        {dataItem.category === 3 && <OtherInquiry data={dataItem} refreshList={refreshList} />}
      </DialogContent>
    </Dialog >
  );

};